module.exports = __webpack_public_path__ + "static/media/4-c.a51285fe.jpg";